import { type HttpClient } from '@/application/interfaces/http-client';

import { postPayment } from './post-payment';

const paymentService = (httpClient: HttpClient.Instance) => ({
  postPayment: postPayment(httpClient),
});

export default paymentService;
